import PayrollDeductionComponents from "../components/PayrollDeduction";
import useIncomeDeductionList from "../hooks/useIncomeDeductionList";

import { PAGE_TYPE } from "../schemas/incomeDeductionSchema";

const PayrollDeduction = () => {
  const useIncomeDeductionListProps = useIncomeDeductionList({
    pageType: PAGE_TYPE.DEDUCTION,
  });
  return <PayrollDeductionComponents {...useIncomeDeductionListProps} />;
};

export default PayrollDeduction;
